/**
 * Analytics labels assigned to specific application action events. These values and events are
 * identified and defined by the Allstate analytics team, later to be implemented here.
 */
export const ANALYTICS_EVENT_ACTION = {
  login: 'login',
  independentAgentLogin: 'login_independentBroker',
  AGND_VIEW_ACCOUNTS_CLICK: 'agentDashboard_viewAccount',
  AGENT_POLICIES_DETAILS_UPLOAD_DOCUMENT: 'agentPoliciesDetails_uploadDocument',
  AGENT_POLICIES_DETAILS_VIEW_CLAIMS: 'agentPoliciesDetails_viewClaims',
  AGENT_POLICIES_DETAILS_VIEW_LETTERS: 'agentPoliciesDetails_viewLetters',
  USER_PROFILE_EDIT_EMAIL_SECTION: 'userProfile_editUserProfile',
  agentDashViewPoliciesClick: 'agentDashboard_viewPolicies',
  AGND_VIEW_COMMISSIONS_CLICK: 'agentDashboard_viewCommisions',
  AGND_VIEW_CORRESPONDENCE_CLICK: 'agentDashboard_viewCorrespondence',
  AGND_VIEW_LEGACY_ACCOUNTS_CLICK: 'agentDashboard_viewLegacyAccounts',
  AGND_VIEW_READ_LATEST_NEWS_CLICK: 'agentDashboard_readLatestNews',
  USER_PROFILE_EDIT_SECURITY_QUESTIONS: 'userProfile_editSecurityQuestions',
  USER_PROFILE_EDIT_MOBILE_SECTION: 'userProfile_editMobile',
  agentDashOpenInNewTabClick: 'agentDashboard_heritageClub',
  AGENT_POLICIES_VIEWCLAIMS_I_AGREE: 'aagentPoliciesViewClaims_iAgree',
  AGENT_POLICIES_CLAIMS: 'agentPolicies_claims',
  ALLSTATE_LOGO: 'allstateLogo',
  searchbar: 'searchbar',
  AGENT_POLICIES_VIEW_DETAILS: 'agentPolicies_viewDetails',
  GLOBAL_USER_PROFILE_DROPDOWN: 'userProfileDropdown',
  GLOBAL_SINGLE_SIGNON: 'singleSignOn',
  GLOBAL_SWITCH_ACCOUNTS: 'switchAccount',
  SINGLE_SIGNON_HEADER: 'singleSignOnHeader_addAccount',
  SINGLE_SIGNON_HEADER_ADD_ACCOUNT_SUBMIT: 'singleSignOnHeaderAddAccount_submit',
  SINGLE_SIGNON_HEADER_ADD_ACCOUNT_CANCEL: 'singleSignOnHeaderAddAccount_cancel',
  SWITCH_ACCOUNTS_APPLY: 'switchAccounts_apply',
  AGTAC_VIEW_DETAILS: 'agentAccount_viewDetails',
  AGTAC_VIEW_POLICIES: 'agentAccount_viewPolicies',
  AGTAC_UPLOAD_ENROLLMENT: 'agentAccount_uploadEnrollment',
  AGTAC_VIEW_DETAILS_VIEW_POLICIES: 'agentAccountViewDetails_viewPolicies',
  AGTAC_VIEW_DETAILS_REQUEST_PIR: 'agentAccountViewDetails_requestPIR',
  POLICIES_VIEW_DETAILS_VIEWCLAIMS: 'agentPoliciesDetails_viewClaims',
  POLICIES_VIEW_DETAILS_VIEWLETTERS: 'agentPoliciesDetails_viewLetters',
  POLICIES_VIEW_DETAILS_UPLOADDOCUMENT: 'agentPoliciesDetails_uploadDocument',
  USER_PROFILE_EDITSECURITYQUESTIONS:'userProfile_editSecurityQuestions',
  USER_PROFILE_EDITMOBILE:'userProfile_editMobile',
  USER_PROFILE_EDITUSERINFO:'userProfile_editUserInfo',
  USER_PROFILE_EDITEMAIL:'userProfile_editUserProfile',
  POLICIES_VIEW_UPLOAD_DOCUMENT_SUBMIT: 'agentPoliciesUploadDocument_submit',
  POLICIES_VIEW_UPLOAD_DOCUMENT_CANCEL:'agentPoliciesUploadDocument_cancel',
  POLICIES_TILE_CLAIMS:'agentPolicies_claims',
  POLICIES_TILE_VIEWDETAILS:'agentPolicies_viewDetails',
  POLICY_VIEW_DETAILS_VIEW_CLAIMS_IAGREE:'agentPoliciesViewClaims_iAgree',
  USER_PROFILE_UPDATEPASSWORD: 'userProfile_updatePassword',
};
